import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';

import Button from '../../../../components/Button';
import Image from '../../../../components/Image';
import SanitizeHTML from '../../../../components/SanitizedHTML';

import NoPhotoImage from './no-photo.png';
import messages from '../../messages';
import '../../styles.css';

const ProfileCardInfoLine = (props) => (
  <React.Fragment>
    { props.text && (
      <p data-cy={props['data-cy']}><strong><FormattedMessage {...props.title} /></strong><br />{props.text}</p>
    )}
  </React.Fragment>
);

ProfileCardInfoLine.propTypes = {
  'title': PropTypes.object,
  'text': PropTypes.string,
  'data-cy': PropTypes.string,
};

class ProfileCard extends React.PureComponent {
  static propTypes = {
    profile: PropTypes.object.isRequired,
    imgDisplayUrl: PropTypes.string,
  };

  state = {
    showMoreInfo: false,
  };

  render() {
    const { showMoreInfo } = this.state;
    const { profile, imgDisplayUrl } = this.props;
    return (
      <div styleName="profile-person" key={profile.imgDisplayUrl}>
        <div styleName="profile-person-image">
          <Image src={imgDisplayUrl || NoPhotoImage} styleName="profile-avatar" avatar />
        </div>
        <div styleName="profile-person-info">
          <div styleName="profiles-person-name" data-cy="Premium-Hem-Profiles-Profile-Name">
            {profile.type === 'program' ? profile.program_name : profile.persons_name}
          </div>
          {(profile.type === 'student' || profile.type === 'alumni') && (
            <div styleName="profiles-person-hometown" data-cy="Premium-Hem-Profiles-Hometown">
              {profile.hometown}
            </div>
          )}
          {(profile.type === 'faculty') && <div styleName="profiles-person-major" data-cy="Premium-Hem-Profiles-Type"> {profile.type} </div>}
          {(profile.type === 'alumni') && <div styleName="profiles-person-major" data-cy="Premium-Hem-Profiles-Major-Alumni"> {profile.major} - {profile.class} </div>}
          {(profile.type === 'student') && <div styleName="profiles-person-major" data-cy="Premium-Hem-Profiles-Major-Student"> {profile.major} {profile.type} </div>}
          <div styleName="profiles-person-quote-container" data-cy="Premium-Hem-Profiles-Quote">
            “<SanitizeHTML html={profile.quote} />“
          </div>
          {showMoreInfo && (
            <div styleName="profiles-person-body-container">
              <SanitizeHTML html={profile.body} data-cy="Premium-Hem-Profiles-Body" />
              <ProfileCardInfoLine title={messages.profilesFavActivitiesTitle} text={get(profile, 'fav_activities[0]')} data-cy="Premium-Hem-Profiles-Activities" />
              <ProfileCardInfoLine title={messages.profilesFavHangoutTitle} text={profile.fav_hangout} data-cy="Premium-Hem-Profiles-Hangout" />
              <ProfileCardInfoLine title={messages.profilesBestPlaceToEatTitle} text={profile.best_place_to_eat} data-cy="Premium-Hem-Profiles-Eat" />
              <ProfileCardInfoLine title={messages.profilesFavEventTitle} text={profile.fav_event} data-cy="Premium-Hem-Profiles-Event" />
              <ProfileCardInfoLine title={messages.profilesFavTraditionsTitle} text={profile.fav_tradition} data-cy="Premium-Hem-Profiles-Traditions" />
              <ProfileCardInfoLine title={messages.profilesTravelTitle} text={profile.travel} data-cy="Premium-Hem-Profiles-Travel" />
            </div>
          )}
          <Button
            data-cy="Premium-Hem-Profiles-ShowLess-Button"
            styleName="links-button"
            content={<FormattedMessage {...(showMoreInfo ? messages.profilesShowLessButton : messages.profilesReadMoreButton)} />}
            onClick={() => this.setState({ showMoreInfo: !showMoreInfo })}
          />
        </div>
      </div>
    );
  }
}

export default ProfileCard;
